// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__lfzAM","content":"styles_content__281dD","checkbox":"styles_checkbox__n8Q-M","checkboxLabel":"styles_checkboxLabel__3kYXa"};